import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoriesForAdmin } from '../../actions/AdminCategoryActions';
import addIcon from '../adminIcons/add.svg'
import AdminModal from '../../app-main-content/AdminModal'
import AddCategory from './AddCategory';
import CategoryItem from './CategoryItem';
import { arrangeCategories } from '../../actions/AdminCategoryActions';
import {
    DndContext, 
    closestCorners,
    KeyboardSensor,
    MouseSensor,
    TouchSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core"
import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy,
    sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";


const AdminCategories = () => {

    const dispatch = useDispatch()

    const [addActive, setAddActive] = useState()

    const [items, setItems] = useState()

    useEffect(()=>{
        dispatch(getCategoriesForAdmin())
    },[])

    const { adminCategories, loadingAdminCategories } = useSelector(state=>state.adminCategories)

    useEffect(()=>{
        if(adminCategories && adminCategories.length){
            setItems(adminCategories)
        }
    },[adminCategories])

    const sensors = useSensors(
        useSensor(MouseSensor, {
        // Require the mouse to move by 10 pixels before activating
        activationConstraint: {
            distance: 10,
        },
        }),
        useSensor(TouchSensor, {
        // Press delay of 250ms, with tolerance of 5px of movement
        activationConstraint: {
            delay: 250,
            tolerance: 5,
        },
        }),
        useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
        })
    );


    const handleDragEnd = (event) => {
        const {active, over} = event;
        if (active.id !== over.id) {
            setItems((items) => {
            const oldIndex = items.map(item=>item.position).indexOf(active.id);
            const newIndex = items.map(item=>item.position).indexOf(over.id);
            if (active.id>over.id){
                items.forEach(item => {
                    if(item.position < active.id && item.position >= over.id){
                        item.position += 1
                    } else if (item.position === active.id){
                        item.position = over.id
                    }
                });
            } else if (active.id<over.id){
                items.forEach(item => {
                    if(item.position > active.id && item.position <= over.id){
                        item.position -= 1
                    } else if (item.position === active.id){
                        item.position = over.id
                    }
                });
            } 
            return arrayMove(items, oldIndex, newIndex);
            });
            dispatch(arrangeCategories(active.id, over.id))
        }
    }


    return (
        <div className = 'col-9 bg-success p-4 my-5 me-5 rounded col-9' style={{marginLeft:"16vw", minHeight:"100vh"}}>
            <div className = 'pb-4 d-flex justify-content-between align-items-center pe-5'>
                <div className = "fw-bold fs-7 text-info" 
                    role='button' 
                >CATEGORIES</div>
                <div className = 'bg-secondary rounded-pill px-3 d-flex align-items-center'
                    style={{height:"40px"}}
                    role='button'
                    onClick = {()=>{setAddActive(true)}}
                    >
                    <img 
                        src = {addIcon}
                        alt = ""
                    />
                    <div className='text-white ps-1 text-nowrap'
                    >Add Category</div>
                </div>
            </div>

                <div className = "my-3 bg-info w-100" style={{height:"2px"}}></div>

                <div className = 'p-3 d-flex'>        
                    <div className = 'text-info col-2 text-center'>Icon</div>            
                    <div className = 'text-info col-5 text-center'>Title</div>
                    <div className = 'text-info col-3 text-center'>Status</div>
                </div>
                {
                    loadingAdminCategories ?
                    <div className = 'text-center text-info'>Loading...</div>
                    :
                    <DndContext 
                        sensors={sensors}
                        collisionDetection={closestCorners}
                        onDragEnd={handleDragEnd}
                    >
                        {
                            items && items.length ? 
                            <SortableContext items = {items.map(category=>category.position)} strategy={verticalListSortingStrategy}>
                                {
                                    items.map((category, index)=>(
                                        <CategoryItem 
                                            index = {index}
                                            category = {category}
                                        />
                                    )) 
                                }
                            </SortableContext> :""
                        }
                    </DndContext>
                }
                <AdminModal 
                    trigger = {addActive}
                    setTrigger = {setAddActive}
                    content = {
                        <AddCategory
                            setIsActive = {setAddActive}
                        /> 
                    }
                /> 
            </div>
    );
};

export default AdminCategories;